interface SignUpTitleProps {
    text: string
}

export function SignUpTitle({ text }: SignUpTitleProps) {
    return (
        <div className="tw-w-full tw-text-4xl tw-font-bold tw-text-neutral-800 ">
            {text}
        </div>
    );
}